module.exports = __webpack_public_path__ + "static/media/bg-measure-what-matters.3336a269.jpg";